import { render, staticRenderFns } from "./TestimonyCard.vue?vue&type=template&id=1303b3da"
import script from "./TestimonyCard.vue?vue&type=script&lang=js"
export * from "./TestimonyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports